import clsx from 'clsx';

function Loading({ inline = false }: { inline?: boolean }) {
    return (
        <div
            className={clsx('flex justify-center', {
                'mt-[300px] min-h-screen w-full': !inline,
            })}>
            <svg
                className="animate-pulse"
                width="36"
                height="25"
                viewBox="0 0 36 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.776 0.127998C12.856 0.127998 11.416 1.312 8.856 3.744L8.952 3.84C9.784 3.232 10.68 2.848 12.248 2.848C14.968 2.848 16.792 4.096 16.792 7.648V24H20.504V6.848C20.504 2.176 18.136 0.127998 14.776 0.127998ZM35.704 20.992L35.64 20.928C35 21.408 34.552 21.632 33.752 21.632C32.12 21.632 30.136 19.904 28.728 19.2L29.752 18.176C31.896 16.032 32.6 15.072 32.6 11.968V7.04C32.6 2.176 30.2 0.127998 26.712 0.127998C24.728 0.127998 23.544 1.024 20.696 3.904L20.792 4C21.784 3.2 22.776 2.848 24.408 2.848C27 2.848 28.888 4.128 28.888 7.648V15.456C28.888 18.304 28.44 18.848 27 20.224L25.624 21.536V21.664C27.064 22.4 29.208 24.512 31.032 24.512C32.408 24.512 33.176 23.744 35.704 20.992ZM4.632 4.032H7.576V4.128C5.336 6.112 4.568 7.264 4.568 9.504V16.192C4.568 18.528 4.408 19.2 3.576 20.192L3.672 20.256L5.016 19.168C7.736 16.96 8.28 15.84 8.28 13.184V4.256C8.28 2.688 8.536 1.696 9.144 0.639999H6.52C4.792 0.639999 3.544 1.152 2.008 2.944L0.28 4.928L0.376 5.024C1.304 4.192 2.008 4.032 4.632 4.032ZM10.712 21.376C8.856 21.376 7.16 20.192 5.24 20.192C3.672 20.192 2.616 21.376 0.408 23.968L0.472 24.032C1.112 23.52 1.56 23.296 2.52 23.296C4.408 23.296 6.136 24.512 7.8 24.512C9.4 24.512 10.136 23.488 12.6 20.768L12.536 20.704C11.96 21.152 11.48 21.376 10.712 21.376Z"
                    fill="black"
                />
            </svg>
        </div>
    );
}

export default Loading;
